import { FilterType } from '../../../../../shared/enums/filter-type.enum'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { Filter } from '../../../../../shared/interfaces/filter.interface'

export const filterGroups: {
  name?: string
  filters: Filter[]
  isHidden?: boolean
}[] = [
  {
    filters: [
      {
        title: 'Search',
        filterType: FilterType.TextInput,
        queryParam: 'terms',
        helpText: 'Search tools by name, concept, keyword, etc.',
        isOpen: true
      }
    ]
  },
  {
    name: 'Type',
    filters: [
      {
        title: 'Approach',
        slug: ResourceSlug.Approaches,
        filterType: FilterType.CheckBox,
        queryParam: 'approachIds',
        relativeResourceObjectKey: 'approaches',
        isOpen: true
      },
      {
        title: 'Tool type',
        slug: ResourceSlug.ToolTypes,
        filterType: FilterType.MultiTags,
        queryParam: 'toolTypeIds',
        relativeResourceObjectKey: 'toolTypes',
        isOpen: true
      }
    ]
  },
  {
    filters: [
      {
        title: 'Objective',
        slug: ResourceSlug.Objectives,
        filterType: FilterType.MultiTags,
        queryParam: 'objectiveIds',
        relativeResourceObjectKey: 'objectives',
        helpText:
          'Tool helps to ensure that AI applications are or help achieve the following objective:',
        isOpen: true
      }
    ]
  },
  {
    filters: [
      {
        title: 'Usage rights',
        slug: ResourceSlug.UsageRights,
        filterType: FilterType.CheckBox,
        queryParam: 'usageRightIds',
        relativeResourceObjectKey: 'usageRights',
        helpText: 'Legal conditions for using the tool'
      }
    ]
  },
  {
    name: 'Origin',
    filters: [
      {
        title: 'Stakeholder group',
        slug: ResourceSlug.StakeholderGroups,
        filterType: FilterType.CheckBox,
        queryParam: 'stakeholderGroupIds',
        relativeResourceObjectKey: 'stakeholderGroups',
        helpText: 'Stakeholder group from which the initiative originates'
      },
      {
        title: 'Country of origin',
        slug: ResourceSlug.Countries,
        filterType: FilterType.MultiTags,
        queryParam: 'countryIds',
        relativeResourceObjectKey: 'countries',
        helpText: 'Country or region where the initiative originated'
      },
      {
        title: 'Organisation',
        slug: ResourceSlug.Organisations,
        filterType: FilterType.MultiTags,
        queryParam: 'organisationIds',
        relativeResourceObjectKey: 'organisations',
        helpText: 'The organisation that developed the tool',
        isOpen: true
      }
    ]
  },
  {
    name: 'Scope',
    filters: [
      {
        title: 'Lifecycle stage(s)',
        slug: ResourceSlug.Lifecycles,
        filterType: FilterType.CheckBox,
        queryParam: 'lifecycleIds',
        relativeResourceObjectKey: 'lifecycles',
        helpText:
          'Stages of the AI system lifecycle that the tool helps to implement'
      },
      {
        title: 'Target group(s)',
        slug: ResourceSlug.TargetGroups,
        filterType: FilterType.CheckBox,
        queryParam: 'targetGroupIds',
        relativeResourceObjectKey: 'targetGroups',
        helpText: 'Stakeholder group expected to use the tool'
      },
      {
        title: 'Target user(s)',
        slug: ResourceSlug.TargetUsers,
        filterType: FilterType.CheckBox,
        queryParam: 'targetUserIds',
        relativeResourceObjectKey: 'targetUsers',
        helpText: 'Expected users of the tool'
      },
      {
        title: 'Target sector(s)',
        slug: ResourceSlug.TargetSectors,
        filterType: FilterType.MultiTags,
        queryParam: 'targetSectorIds',
        relativeResourceObjectKey: 'targetSectors',
        helpText: 'Policy area(s) where the tool is expected to be implemented'
      },
      {
        title: 'Impacted stakeholders',
        slug: ResourceSlug.ImpactedStakeholder,
        filterType: FilterType.CheckBox,
        queryParam: 'impactedStakeholderIds',
        relativeResourceObjectKey: 'impactedStakeholders',
        helpText:
          'Groups of people that will be impacted by the use of the tool'
      },
      {
        title: 'Purpose(s)',
        slug: ResourceSlug.Purposes,
        filterType: FilterType.CheckBox,
        queryParam: 'purposeIds',
        relativeResourceObjectKey: 'purposes',
        helpText: 'Purpose or action of the AI system'
      }
    ]
  },
  {
    filters: [
      {
        title: 'Tool readiness',
        slug: ResourceSlug.Maturity,
        filterType: FilterType.CheckBox,
        queryParam: 'maturityIds',
        relativeResourceObjectKey: 'maturities',
        helpText: 'Project phase the tool is currently in'
      }
    ]
  },

  {
    isHidden: true,
    filters: [
      {
        title: 'Validity',
        slug: ResourceSlug.Validities,
        filterType: FilterType.CheckBox,
        queryParam: 'validityIds',
        relativeResourceObjectKey: 'validities'
      },
      {
        title: 'Enforcements',
        slug: ResourceSlug.Enforcement,
        filterType: FilterType.CheckBox,
        queryParam: 'enforcementIds',
        relativeResourceObjectKey: 'enforcements'
      },
      {
        title: 'Benefits',
        slug: ResourceSlug.Benefit,
        filterType: FilterType.CheckBox,
        queryParam: 'benefitIds',
        relativeResourceObjectKey: 'benefits'
      },
      {
        title: 'Geographical scope',
        slug: ResourceSlug.GeographicalScope,
        filterType: FilterType.CheckBox,
        queryParam: 'geographicalScopeIds',
        relativeResourceObjectKey: 'geographicalScopes'
      },
      {
        title: 'People involved',
        slug: ResourceSlug.PeopleInvolved,
        filterType: FilterType.CheckBox,
        queryParam: 'peopleInvolvedIds',
        relativeResourceObjectKey: 'peopleInvolveds'
      },
      {
        title: 'Required skills',
        slug: ResourceSlug.RequiredSkills,
        filterType: FilterType.CheckBox,
        queryParam: 'requiredSkillIds',
        relativeResourceObjectKey: 'requiredSkills'
      },
      {
        title: 'Technology platforms',
        slug: ResourceSlug.TechnologyPlatform,
        filterType: FilterType.CheckBox,
        queryParam: 'technologyPlatformIds',
        relativeResourceObjectKey: 'technologyPlatforms'
      },
      {
        title: 'Programming languages',
        slug: ResourceSlug.ProgrammingLanguages,
        filterType: FilterType.CheckBox,
        queryParam: 'programmingLanguageIds',
        relativeResourceObjectKey: 'programmingLanguages'
      }
    ]
  }
]
